<template>
  <div>
    <label class="d-block">
      {{ $t(`commands.panels.${config.label}`) }}
    </label>
    <validation-provider
      :name="$t(config.label)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        label="text"
        :options="devices"
        v-model="model"
        :clearable="false"
        :reduce="(val) => val.device_id"
        input-id="device-id"
        :multiple="multiple"
        @input="actionSelected($event)"
      />
      <!--  <p class="mb-0 small">{{ config.label }}</p> -->
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import axios from '@axios';
import vSelect from "vue-select";
import {EventBus} from "@/libs/event-bus";
import {ValidationProvider} from "vee-validate";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
  },
  data() {
    return {
      model: null,
      devices: []
    };
  },
  created() {
    this.model = this.value;
  },
  async mounted() {
    if (this.model) {

    }
  },
  watch: {
    "context.model.user_panel": {
      async handler(value) {
        if (value && !this.devices.length) {
          await this.getDevices(value)
          if (this.model) await this.actionSelected(this.model);
        }
      },
      immediate: true
    }
  },
  methods: {
    actionSelected(device_id) {
      const {actions} = this.devices.find(device => device.device_id === device_id);
      const actionSelected = [];

      for (const action of actions) {
        const {data} = action;

        actionSelected.push({
          name: data.action_name,
          url: data.url
        });
      }

      this.$nextTick(() => {
        this.$emit('input', device_id);
        EventBus.emit('actions-selected', actionSelected)
      });
    },
    async getDevices(camera_proxy_id) {
      const {data} = await axios.get(`/v1/services/alarm-panel/info?device_proxy_id=${camera_proxy_id}&withDevices=true`);

      this.getDevicesForType(data.data.devices);
    },
    getDevicesForType(devices) {
      const isDmpPanel = (this.config.subtype === 'dmp_device_panel');

      if (isDmpPanel) {
        this.getDmpDevices(devices);
        return
      }

      this.devices = devices.map((device, index) => {
        return {
          actions: device.actions,
          device_id: device.device_id,
          text: device.text
        }
      });
    },
    getArrayDevicesDmp(deviceType) {
      for (const device of deviceType) {
        const {device_type} = device;
        const isDmpArea = (device_type === 'area');

        if (isDmpArea) {
          const deviceWithDevices = (device.devices && device.devices.length);

          this.devices.push({
            actions: device.actions,
            device_id: `${device.device_id}:${device.device_type}`,
            text: `${device.text} ---`
          });

          if (deviceWithDevices) {
            for (const deviceInDevice of device.devices) {
              this.devices.push({
                actions: deviceInDevice.actions,
                device_id: `${deviceInDevice.device_id}:${deviceInDevice.device_type}`,
                text: `${deviceInDevice.text} (${device.text})`
              });
            }
          }

          continue;
        }

        this.devices.push({
          actions: device.actions,
          device_id: `${device.device_id}:${device.device_type}`,
          text: device.text
        });
      }
    },
    getDmpDevices(devices) {
      for (const key in devices) {
        const device = devices[key];
        const isArray = Array.isArray(device);
        const arrayWithValues = (device.length);

        if (isArray && arrayWithValues) {
          this.getArrayDevicesDmp(device);
          continue;
        } else if (!isArray) {
          this.devices.push({
            actions: device.actions,
            device_id: `${device.device_id}:${device.device_type}`,
            text: device.text
          });
        }
      }
    }
  }
};
</script>

<style></style>
